module.exports = __webpack_public_path__ + "img/finance-illustration-01.eb3bc7b1.png";